<template lang="html">
  <section class="countries">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="countries_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-2">Enabled:</div><b-form-select class="col-lg-3" v-model="filter.enabled">
                  <b-form-select-option :value="null">---</b-form-select-option>
                  <b-form-select-option :value="true">Yes</b-form-select-option>
                  <b-form-select-option :value="false">No</b-form-select-option>
                </b-form-select>
                <div class="col-lg-1"></div>
                <div class="col-lg-2">Code:</div><input type="text" class="col-lg-3" v-model="filter.id" placeholder="Code"/>
              </div>
              <div class="row mt-3">
                <div class="col-lg-2">Iso-code:</div><input type="text" class="col-lg-3" v-model="filter.isoCode2" placeholder="Iso-code"/>
                <div class="col-lg-1"></div>
                <div class="col-lg-2">Adm:</div><input type="text" class="col-lg-3" v-model="filter.tabele" placeholder="Adm"/>
              </div>
              <b-button variant="primary" v-b-toggle.countries_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Countries</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination align="fill" limit="6" v-model="currentPage" :total-rows="totalRowsResult"
                  :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" ellipsisText="..."
                  aria-controls="" class="col-lg-10"></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">    
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.countries_filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new @click="btnNew" v-if="false"><i class="mdi mdi-plus"></i>New</b-button>
              </span>
            </div>
            <b-table ref="countries_tab" id="table" striped hover responsive :items="items" :fields="fields"
              :per-page="perPage" :current-page="1" primary-key="id" no-local-sorting no-provider-paging sort-icon-left>
              <!-- InfoButtons -->
              <template v-slot:cell(infoButtons)="data" lang="html">
                <div class="d-flex justify-content-center">
                  <b-row class="mr-0" style="margin-left: 0; float: left; padding: 2px;">
                    <b-button class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                      v-b-tooltip.hover title="Country Model List" @click="countryModelList(data.item.id)">
                      <i class="mdi mdi-information-outline"></i>
                    </b-button>
                  </b-row>
                  <b-row class="mr-0" style="margin-left: 15px; float: left; padding: 2px;">
                    <b-button v-if="data.item.id!=codeCountryDefault && curModel!='DEFAULT'" class="col-lg-3 p-1 m-auto"
                      size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Check Grid"
                      @click="curItem=data.item; checkGrid(data.item.id)">
                      <i class="mdi mdi-grid"></i>
                    </b-button>
                    <b-button v-else class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                      v-b-tooltip.hover title="Check Grid" disabled>
                      <i class="mdi mdi-grid"></i>
                    </b-button>
                  </b-row>
                </div>
              </template>

              <template v-slot:cell(editButton)="data" lang="html">
                <b-row style="margin-left: 15px; float: left; padding: 2px;">
                  <b-button class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                    v-b-tooltip.hover title="Edit Country" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                </b-row>
                <b-row style="margin-left: 15px; float: left; padding: 2px;">
                  <b-button class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="success"
                    v-b-tooltip.hover title="Save Row" @click="saveCurItem(data.item)">
                    <i class="mdi mdi-content-save"></i>
                  </b-button>
                </b-row>
              </template>

              <!-- GridButtons-->
              <template v-slot:cell(gridButtons)="data" lang="html">
                <div class="d-flex justify-content-center">
                  <b-row class="mr-0" style="margin-left: 0; float: left; padding: 2px;">
                    <b-button v-if="data.item.id!=codeCountryDefault && curModel!='DEFAULT'" class="col-lg-3 p-1 m-auto"
                      size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Config Grid Json"
                      @click="curItem=data.item; gridJSON(data.item.id)">
                      <i class="mdi mdi-json"></i>
                    </b-button>
                    <b-button v-else class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                      v-b-tooltip.hover title="Config Grid Json" disabled>
                      <i class="mdi mdi-json"></i>
                    </b-button>
                  </b-row>
                  <b-row class="mr-0" style="margin-left: 15px; float: left; padding: 2px;">
                    <b-button v-if="data.item.id!=codeCountryDefault && curModel!='DEFAULT'" class="col-lg-3 p-1 m-auto"
                      size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Car Grid Txt"
                      @click="curItem=data.item; carGridTxt(data.item.id)">
                      <i class="  mdi mdi-car-sports"></i>
                    </b-button>
                    <b-button v-else class="col-lg-3 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                      v-b-tooltip.hover title="Car Grid Txt" disabled>
                      <i class="  mdi mdi-car-sports"></i>
                    </b-button>
                  </b-row>
                </div>
              </template>

              <template v-slot:cell(automaticPrice)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto; cursor: pointer;" @click="!data.item.automaticPrice && toggleAutomaticPrice(data.item)">
                    <i v-if="!data.item.automaticPrice" class="mdi mdi-close-outline btn-outline-secondary"></i>
                    <i v-else class="mdi mdi-check-outline btn-outline-success" style="display: block; opacity: 0.4;"></i>
                  </h4>
                </b-row>
              </template>

              <template v-slot:cell(minMyPrice)="data" lang="html">
                <b-row>
                  <input type="number" class="m-auto" style="width: 5rem;"
                    v-model.number="data.item.minMyPrice" placeholder="min MY" />
                </b-row>
              </template>

              <template v-slot:cell(minMyFe)="data" lang="html">
                <b-row>
                  <input type="number" class="m-auto" style="width: 5rem;"
                    v-model.number="data.item.minMyFe" placeholder="min MY" />
                </b-row>
              </template>

              <template v-slot:cell(enabled)="data" lang="html">
                <b-row>
                  <h4 class="panel-title" style="margin:auto;">
                  <b-button v-if="!data.item.enabled" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Enabled to True" @click="data.item.enabled=true; toggleAndSaveEnabled(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Enabled to False" @click="data.item.enabled=false; toggleAndSaveEnabled(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                  </h4>
                </b-row>

              </template>


              <template v-slot:cell(model_management)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-3 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary"
                    title="Apri gestione modelli"
                    @click='goToCountryModels(data.item.id,data.item.id + " - " + data.item.isoCode2 + " - " + getCountryDescriptionByLang(data.item,curLanguage))'>
                    <i class="mdi mdi-link-variant"></i>
                  </b-button>
                </b-row>
              </template>


              <template v-slot:cell(country_translation)="data" lang="html">
                <b-row style="margin-left: 0; float: left; padding: 2px;">
                  <input disabled type="text" :value="getCountryDescriptionByLang(data.item,curLanguage)"
                    class="col-lg-10" />
                </b-row>
              </template>
            </b-table>
            <b-tooltip target="tooltip-target-1" triggers="hover">
            </b-tooltip>
            <b-modal id="opt-color-details" title="Details Edit" v-if="curItem" size="lg" header-bg-variant="primary"
              header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <b-table ref="countries_tab" id="table" striped hover responsive :items="items" :fields="fields"
                    :per-page="perPage" :current-page="currentPage" primary-key="code" no-local-sorting
                    no-provider-paging sort-icon-left> <!-- A custom formatted column -->
                    <template v-slot:cell(accordionButton)="data" lang="html">
                      <b-row>
                        <h4 class="panel-title" style="margin:auto;">
                          <a role="button" data-toggle="collapse" href="javascript:void(0);"
                            @click="expandItem(data.item)" aria-expanded="true" aria-controls="collapseOne">
                            <i class="mdi mdi-arrow-right-drop-circle-outline"></i>
                          </a>
                        </h4>
                      </b-row>
                    </template>
                    <!-- A custom formatted column -->
                    <template v-slot:cell(buttons)="data" lang="html">
                      <b-row>
                        <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"
                          v-b-modal.modal-edit @click="curItem=data.item">
                          <i class="mdi mdi-pencil"></i>
                        </b-button>
                        <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger"
                          @click="deleteItem(data.item)">
                          <i class="mdi mdi-delete"></i>
                        </b-button>
                      </b-row>
                    </template>
                  </b-table>
                </b-row>
              </b-container>
            </b-modal>
            <b-modal id="modal-edit" title="Modal Edit" v-if="curItem" size="lg" header-bg-variant="primary"
              header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <ul class="nav nav-tabs" id="editCountryTab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('textFields') }" id="textFieldstab"
                        @click.prevent="setActive('textFields')" data-toggle="tab" href="#textFields" role="tab"
                        aria-controls="textFields" aria-selected="true">Translations</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFieldstab"
                        @click.prevent="setActive('checkboxFields')" data-toggle="tab" href="#checkboxFields" role="tab"
                        aria-controls="checkboxFields" aria-selected="false">Configuration</a>
                    </li>
                  </ul>
                  <!-- booleans -->
                  <div class="col-lg-12">
                    <div class="tab-pane fade col-lg-12" role="tabpanel" aria-labelledby="checkboxFieldstab"
                      :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFields">

                      <div class="col-lg-12">
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Country Id:</div>
                          <input type="text" class="col-lg-3" placeholder="Country Id" v-model="curItem.id" disabled />
                          <div class="col-lg-1"></div>
                            <div class="col-lg-2">Adm:</div>
                            <input type="text" class="col-lg-3" placeholder="Adm" v-model="curItem.tabele" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Codmercato:</div>
                            <input type="text" class="col-lg-3" placeholder="Codmercato" v-model="curItem.codmercato" />
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Geo Region:</div>
                            <input type="text" class="col-lg-3" placeholder="Geo Region"  v-model="curItem.geoRegion" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date:</div>
                            <input type="text" class="col-lg-3" placeholder="Format Date" v-model="curItem.formatDate" />
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Iso code 2:</div>
                            <input type="text" class="col-lg-3" placeholder="Iso code 2" v-model="curItem.isoCode2" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date month:</div>
                            <input type="text" class="col-lg-3" placeholder="Format Date month" v-model="curItem.formatDateMonth" />
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Iso code 3:</div>
                             <input type="text" class="col-lg-3" placeholder="Iso code 3" v-model="curItem.isoCode3"/>
                        </div>
                      </div>
                      <hr>
                      <div class="row col-lg-6">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheckAutomaticPrice"
                            v-model="curItem.automaticPrice" :disabled="curItem.automaticPrice">
                          <label class="custom-control-label" for="customCheckAutomaticPrice">Automatic Price</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck2"
                            v-model="curItem.enabled">
                          <label class="custom-control-label" for="customCheck2">Enabled</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck3" v-model="curItem.hidden">
                            <label class="custom-control-label" for="customCheck3">Hidden</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck4"
                            v-model="curItem.enableAccessories">
                          <label class="custom-control-label" for="customCheck4">Enable Accessories</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck5"
                            v-model="curItem.enableCustomerPrg">
                          <label class="custom-control-label" for="customCheck5">Enable Custom Program</label>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade col-lg-10" role="tabpanel" aria-labelledby="textFieldstab"
                      :class="{ 'active show': isActive('textFields') }" id="textFields">

                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc En:</div><input type="text" class="col-lg-3" placeholder="Label"
                          v-model="curItem.descEn" />
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc De:</div>
                        <input type="text" class="col-lg-3" placeholder="Desc De" v-model="curItem.descDe" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Fr:</div><input type="text" class="col-lg-3" placeholder="Label"
                          v-model="curItem.descFr" />
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc It:</div>
                        <input type="text" class="col-lg-3" placeholder="Desc It" v-model="curItem.descIt" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Es:</div><input type="text" class="col-lg-3" placeholder="Label"
                          v-model="curItem.descEs" />
                      </div>
                      <hr>
                    </div>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment>
                  <!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="ok();saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-new-int-lab" title="New Country" size="lg" header-bg-variant="primary"
              header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <ul class="nav nav-tabs" id="newCountryTab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('textFields') }" id="textFieldstab"
                        @click.prevent="setActive('textFields')" data-toggle="tab" href="#textFields" role="tab"
                        aria-controls="textFields" aria-selected="true">Text Fields</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFieldstab"
                        @click.prevent="setActive('checkboxFields')" data-toggle="tab" href="#checkboxFields" role="tab"
                        aria-controls="checkboxFields" aria-selected="false">checkboxFields</a>
                    </li>
                  </ul>
                  <!-- booleans -->
                  <div class="col-lg-12">
                    <div class="tab-pane fade col-lg-12" role="tabpanel" aria-labelledby="checkboxFieldstab"
                      :class="{ 'active show': isActive('checkboxFields') }" id="checkboxFields">

                      <div class="col-lg-12">
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Country Id:</div>
                          <input type="text" class="col-lg-3" placeholder="Country Id" v-model="newItem.id"/>
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Adm:</div>
                          <input type="text" class="col-lg-3" placeholder="Adm" v-model="newItem.tabele" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Codmercato:</div>
                            <input type="text" class="col-lg-3" placeholder="Codmercato" v-model="newItem.codmercato" />
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Geo Region:</div>
                            <input type="text" class="col-lg-3" placeholder="Geo Region" v-model="newItem.geoRegion" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date:</div>
                            <input type="text" class="col-lg-3" placeholder="Format Date" v-model="newItem.formatDate" />
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Iso code 2:</div>
                            <input type="text" class="col-lg-3" placeholder="Iso code 2" v-model="newItem.isoCode2" />
                        </div>
                        <hr>
                        <div class="row col-lg-12">
                          <div class="col-lg-2">Format Date month:</div>
                            <input type="text" class="col-lg-3" placeholder="Format Date month" v-model="newItem.formatDateMonth" />
                          <div class="col-lg-1"></div>
                          <div class="col-lg-2">Iso code 3:</div>
                             <input type="text" class="col-lg-3" placeholder="Iso code 3" v-model="newItem.isoCode3"/>
                        </div>
                      </div>
                      <hr>
                      <div class="row col-lg-6">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck2"
                            v-model="newItem.enabled">
                          <label class="custom-control-label" for="customCheck2">Enabled</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck3" v-model="newItem.hidden">
                          <label class="custom-control-label" for="customCheck3">Hidden</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck4"
                            v-model="newItem.enableAccessories">
                          <label class="custom-control-label" for="customCheck4">Enable Accessories</label>
                        </div>
                        <hr>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheck5"
                            v-model="newItem.enableCustomerPrg">
                          <label class="custom-control-label" for="customCheck5">Enable Custom Program</label>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade col-lg-10" role="tabpanel" aria-labelledby="textFieldstab"
                      :class="{ 'active show': isActive('textFields') }" id="textFields">

                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc En:</div><input type="text" class="col-lg-3" placeholder="Label"
                          v-model="newItem.descEn" />
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc De:</div>
                        <input type="text" class="col-lg-3" placeholder="Desc De" v-model="newItem.descDe" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Fr:</div><input type="text" class="col-lg-3" placeholder="Label"
                          v-model="newItem.descFr" />
                      </div>
                      <hr>
                      <div class="row col-lg-12">
                        <div class="col-lg-2">Desc It:</div>
                        <input type="text" class="col-lg-3" placeholder="Desc It" v-model="newItem.descIt" />
                        <div class="col-lg-2"></div>
                        <div class="col-lg-2">Desc Es:</div><input type="text" class="col-lg-3" placeholder="Label"
                          v-model="newItem.descEs" />
                      </div>
                      <hr>
                    </div>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment>
                  <!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="ok();createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'countries',
  methods: {
    checkGrid(idCountry){ 
      this.setSpinnerStatus(true);    
      this.axios
      .get('/ccb/auth/api/checkGrid/'+idCountry+'/'+this.getCurModel,  {
        params:null,
        ...this.authHeader}          
          )
          .then((response) => {            
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'pre',
                {
                  domProps: { innerHTML: response.data }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                   document.querySelector('.modal-body pre').classList.add('external-text')                   
                   document.querySelector('.modal-dialog-centered').style.cssText = "max-width: 80vw;width: 80vw;"
                }, 10);                 
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    gridJSON(idCountry){ 
      this.setSpinnerStatus(true);    
      this.axios
      .get('/ccb/auth/api/getConfigGrid/',  {
        params: {country:idCountry,model: this.getCurModel7DigitsCode, language: this.getCurLanguage},
        ...this.authHeader}          
          )
          .then((response) => {            
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'code',
                {
                  domProps: { innerHTML: JSON.stringify(response.data) }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                   document.querySelector('.modal-body code').classList.add('external-text')                   
                   document.querySelector('.modal-dialog-centered').style.cssText = "max-width: 80vw;width: 80vw;"
                }, 10);                  
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
     carGridTxt(idCountry){
        this.setSpinnerStatus(true);   
      this.axios
      .get('/ccb/auth/api/carGridTxt/'+idCountry+'/'+this.getCurModel7DigitsCode+'/'+this.getCurLanguage,  {
        params: null,
        ...this.authHeader}          
          )
          .then((response) => {            
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'div',
                {
                  domProps: { innerHTML: response.data, class: "external-text" }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                   document.querySelector('.modal-body div').classList.add('external-text')
                  document.querySelector('.modal-dialog-centered').classList.add('scaled')  
                }, 10);
         //(response.data.content)                   
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    countryModelList(id){    
       this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/api/countryModel/getModelListByCountry',  {
        params: {country: id},
        ...this.authHeader}          
          )
          .then((response) => {
            console.log(response.data)
            window.datas = response.data;
             
            const messageNodes = this.$createElement(
                'pre',
                {
                  domProps: { innerHTML: response.data }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                  document.querySelector('.modal-dialog-centered').classList.add('scaled')  
                }, 10);
         //(response.data.content)                   
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    goToCountryModels(idKey,title){
      this.$router.push({name: "country_models", params: { idKey : idKey, from: 'countries',title: title }}); 
    },
    toggleAndSaveEnabled(item,visibilityValue) {
      this.saveCurItem(item);         
    },  
    saveCurItem(curItem) {
      window.curr = curItem
      this.setSpinnerStatus(true);
      this.axios
        .put('/ccb/auth/fe/country/' + curItem.id, curItem ,this.authHeader)
        .then(response => {
          if(response.status == 200) {            
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
          }
          this.setSpinnerStatus(false);
          this.refreshTable();
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          this.setSpinnerStatus(false);
        })
    },
    createItem() {
      this.setSpinnerStatus(true);
      this.axios
      .post('/ccb/auth/fe/country', this.newItem, this.authHeader)
        .then(response => {
          if(response.status == 200) {
            this.$bvModal.msgBoxOk(response.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            this.setSpinnerStatus(false);
            this.refreshTable();
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          this.setSpinnerStatus(false);
        })
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc }
      
      this.axios
      .post('/ccb/auth/fe/country/paged', this.filter, {params: params, ...this.authHeader})
        .then((response) => {
          this.setCountryList(response.data.content)    
          this.totalRowsResult=response.data.totalElements;      
          this.setSpinnerStatus(false);           
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          this.setSpinnerStatus(false);
        })
    },
    btnNew() {
      this.newItem = {id:null, codmercato: null, tabele: null, geoRegion: null,formatDate: null, formatDateMonth: null,  enabled : false, hidden: false, enableAccessories: false, enableCustomerPrg: false, enableWltpEmissions: false, enableNedcComsumptions: false, descEn : null ,descDe: null , descFr: null, descIt: null, descEs: null,isoCode2: null, isoCode : null};
    },
    refreshTable() {
      this.search();
    },
    getCountryDescriptionByLang(item,curLanguage){
      var label = 'descEn'
      Object.keys(item).forEach((key)=>{
        var bapp = curLanguage.toUpperCase()
        var bln = curLanguage.length

        var aLan = key.substr(bln*-1).toUpperCase()
      
        if(aLan == bapp)
          label = key 
      }) 
      return item[label]
    },
    isActive (menuItem) {
      return this.activeNewCountryTab === menuItem
    },
    setActive (menuItem) {
      this.activeNewCountryTab = menuItem
    },
    toggleAutomaticPrice(item) {
      const newValue = !item.automaticPrice;
      let langDesc = this.getCountryDescriptionByLang(item,this.curLanguage)

      this.$bvModal.msgBoxConfirm(
        `Do you really want  ${newValue ? 'enable' : 'disable'} Automatic pricing for country ${langDesc}?`,
        {
          title: 'Confirm',
          okVariant: 'success',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          centered: true,
        }
      )
        .then(confirmed => {
          if (!confirmed) return;

          const payload = { ...item, automaticPrice: newValue };

          this.setSpinnerStatus(true);

          this.axios
            .post(`/ccb/auth/fe/country/${item.id}/automaticPrice` , null, { params: { value: newValue }, ...this.authHeader })
            .then(response => {
              this.$bvModal.msgBoxOk('Done.', {
                okVariant: 'success',
                centered: true
              });

              this.refreshTable();
            })
            .catch(err => {
              this.$bvModal.msgBoxOk('Error while saving.', {
                okVariant: 'danger',
                centered: true
              });
            })
            .finally(() => {
              this.setSpinnerStatus(false);
            });
        });
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',
      'setCountryList'
    ])
  },
  data () {
    return { 
      codeCountryDefault: 0,
      activeNewCountryTab: 'textFields',
      totalRowsResult: 0,
      currentPage:1,
      perPage:10,
      sortBy:'id',      
      sortDesc: false,
      curItem: null,
      filter: {id: null, tabele: null, isoCode2: null, enabled: null},
      newItem : {id:null, codmercato: null, tabele: null, geoRegion: null,formatDate: null, formatDateMonth: null,  enabled : false, hidden: false, enableAccessories: false, enableCustomerPrg: false, enableWltpEmissions: false, enableNedcComsumptions: false, descEn : null ,descDe: null , descFr: null, descIt: null, descEs: null,isoCode2: null, isoCode : null},
      fields: [
        {
          key: 'enabled',
          label: 'Enabled',
          sortable: false,
          thStyle: { whiteSpace: 'nowrap !important' }
        },
        {
          key: 'id',
          label: 'Code',
          sortable: false,
          thStyle: { whiteSpace: 'nowrap !important' }
        },
        {
          key: 'isoCode2',
          label: 'iso-code',
          sortable: false,
          thStyle: { whiteSpace: 'nowrap !important' }
        },
        {
          key: 'country_translation',
          label: 'Description',
          sortable: false
        },
        {
          key: 'tabele',
          label: 'Adm',
          sortable: false,
          thStyle: { whiteSpace: 'nowrap !important' }
        },
        {
          key: 'automaticPrice',
          label: 'Automatic Price',
          sortable: false,
          thStyle: { wordBreak: 'normal !important' }
        },
        {
          key: 'minMyPrice',
          label: 'min MY (price console)',
          sortable: false,
          thStyle: { wordBreak: 'normal !important' }
          
        },
        {
          key: 'minMyFe',
          label: 'min MY (front-end)',
          sortable: false,
          thStyle: { wordBreak: 'normal !important' }
        },
        {
          key: 'model_management',
          label: 'Model Management',
          sortable: false,
          visible : true,
          thStyle: { wordBreak: 'normal !important' }
        },                
        {                  
          key: 'infoButtons',
          label: 'Info',
          sortable: false,
          thStyle: { minWidth: '9.5rem' }
        },
        {
          key: 'gridButtons',
          label: 'Grid',
          sortable: false,
          thStyle: { minWidth: '9.5rem' }
        },
        {
          key: 'editButton',
          label: '',
          sortable: false,
          thStyle: { minWidth: '10rem' }
        }
      ]
    }
  },
  computed: {
    items () {
      return (this.getCountryList && this.getCountryList.length) ? this.getCountryList : [];
    },
    ...mapState([
      'curLanguage',
      'curModel'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getCurUser',
      'authHeader',
      'getCurLanguage',
      'getCurModel',
      'getCountryList'
    ])
  },
   watch: {
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this
    this.search();
    this.setCurApp('ccadm');
  }
}
</script>
<style>
.modal-dialog-centered.scaled {
  max-width: 90vw !important;
  margin: 15vh auto !important;
  text-align: center;
  max-height: 50vh !important;
  min-height: 70vh !important;
  transform: scale(0.9) !important;
}
</style>
<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
.btn i {
  margin: auto !important;
}
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
.table {
  td, th {
    white-space: normal !important;
    word-break: break-word;
    text-align: center;
  }
}
</style>
